import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/styles';

import ModalContainer from 'bento-ordering/base/containers/ModalContainer';

import Dialog from '@material-ui/core/Dialog';
import DialogContent from '@material-ui/core/DialogContent';

import { CHILDREN_PROPTYPES } from 'bento-ordering/base/constants/propTypes';

const styles = theme => ({
  root: {
    padding: 0,
    width: '396px',
    borderRadius: '8px',
    [theme.breakpoints.down('xs')]: {
      width: 'auto'
    }
  }
});

class Modal extends React.Component {
  static propTypes = {
    children: CHILDREN_PROPTYPES.isRequired,
    classes: PropTypes.object.isRequired,
    onClose: PropTypes.func,
    alert: PropTypes.string,
    alertComponent: PropTypes.node
  };

  render() {
    const { classes, onClose, alert, alertComponent } = this.props;
    return (
      <ModalContainer>
        <Dialog open={true} onClose={onClose} aria-labelledby="oo-form-dialog">
          {// This renders the OrderAlertManager from OrderSettingModal
          alert && alertComponent}
          <DialogContent classes={classes}>
            {' '}
            {this.props.children}
          </DialogContent>
        </Dialog>
      </ModalContainer>
    );
  }
}

export default withStyles(styles)(Modal);
